import { Table as TableBase } from "@devexpress/dx-react-grid";
import { Table } from "@devexpress/dx-react-grid-bootstrap4";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Card, CardDeck, Row as SimpleRow } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import ContentWrapper from "../../../../../components/content-wrapper";
import { Message } from "../../../i18n";

export const CrudListContainer = styled(ContentWrapper)<{
  odd: boolean;
  resultsMsg: string;
  addBottomMarginToColumnOverlay: boolean;
}>`
  display: flex;
  flex-flow: column nowrap;
  height: 106%;

  .dx-g-bs4-paging-panel {
    display: flex;
    flex-flow: row-reverse;
    justify-content: space-between;
  }

  .dx-g-bs4-paging-panel > nav {
    margin-right: auto;
    float: none !important;
  }

  .dx-g-bs4-paging-panel > div {
    display: flex !important;
    align-items: center;
  }

  .dx-g-bs4-paging-panel > div:first-child {
    padding-left: 20px;
    position: relative;
  }

  .dx-g-bs4-paging-panel > div:first-child:before {
    position: absolute;
    left: -150px;
    font-weight: 600;
    content: "${props => props.resultsMsg}";

  }

  .dx-g-bs4-table-head {
    font-size: 11px;
    color: ${({ theme }) => theme.regularTextColor};
    font-family: ${({ theme }) => theme.regularTextTypeface};
  }

  .alert {
    margin-bottom: 0;
  }

  .table-responsive {
    background-color: rgb(245, 247, 250);

    .table {
      td {
        font-size: 11px;
        word-break: break-word;
        padding: 0 5px;
        vertical-align: middle;
      }

      margin-bottom: 0;

      tr td:first-child,
      th:first-child {
        padding-left: 20px;
      }

      th > div > div {
        text-transform: uppercase;
      }

      th {
        padding: 5px;
        max-width: 100px;
        word-break: break-word;
        background-color: rgb(250, 251, 252);
      }
    }
  }

  .even {
    background-color: rgb(250, 251, 252) !important;
  }

  .odd {
    background-color: rgb(245, 247, 250) !important;
  }

  .dx-g-bs4-fixed-cell {
    border-left: 1px solid rgb(222, 226, 230);
    z-index: 0;
  }

  .dx-g-bs4-header-cell.dx-g-bs4-fixed-cell {
    background-color: rgb(250, 251, 252) !important
  }

  .dx-g-bs4-toolbar .popover-inner {
    margin-bottom: ${props => (props.addBottomMarginToColumnOverlay ? "80px" : "0")};
  }
}
`;

export const StyledTableRow = styled(SortableElement<TableBase.DataRowProps>(Table.Row))`
  height: 40px;
  background-color: ${props =>
    props.index % 2 === 0 ? "rgb(245, 247, 250)" : "rgb(250, 251, 252)"};
`;

export const StyledTableBody = styled(SortableContainer(Table.TableBody))``;

export const StyledCard = styled(Card)`
  border: 0;
  margin: 0 !important;
`;

export const StyledSimpleRow = styled(SimpleRow)`
  margin: 5px;
`;

export const CustomCardTitle = styled(Card.Title)`
  display: inline-block;
  cursor: pointer;
`;

export const TitleChevronContainer = styled.span`
  display: flex;
  align-items: center;
  max-width: 90vw;

  & > span:nth-child(2) {
    margin-right: 15px;
  }
`;

export const Chevron = styled.span<{ toggleClosed: boolean }>`
  margin-left: 10px;
  border: solid ${({ theme }) => theme.regularTextColor};
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: ${props => (props.toggleClosed ? "rotate(45deg)" : "rotate(-135deg)")};
`;

export const StyledCardDeck = styled(CardDeck)`
  margin-left: -5px;
  margin-bottom: 10px;
`;

export const ColumnsMessage = styled.h5`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ExportButton = styled(Button)`
  height: 33px;
  margin-right: 14px;
  margin-left: 10px;
`;

export const StyledReactTooltip = styled(ReactTooltip)`
  text-transform: none;
  border-radius: 5px;
`;

export const Loader = ({ loadMessage }: { loadMessage: Message }) => (
  <td colSpan={2} style={{ padding: "50px 0px" }}>
    <div style={{ display: "inline-block", position: "sticky", left: "50%" }}>
      <big
        className="text-muted"
        style={{
          display: "inline-block",
          transform: "translateX(-50%)",
          textAlign: "center",
        }}>
        <FormattedMessage {...loadMessage} />
        <br />
        <FontAwesomeIcon icon={faSyncAlt} spin />
      </big>
    </div>
  </td>
);

export const LoadError = ({
  retry,
  failMessage,
  retryMessage,
}: {
  retry?: () => void;
  failMessage: Message;
  retryMessage: Message;
}) => (
  <td colSpan={2} style={{ padding: "50px 0px" }}>
    <div style={{ display: "inline-block", position: "sticky", left: "50%" }}>
      <big className="text-muted" style={{ display: "inline-block" }}>
        <FormattedMessage {...failMessage} />
      </big>
      <br />
      <Button style={{ display: "inline-block" }} size="sm" onClick={retry}>
        <FormattedMessage {...retryMessage} />
      </Button>
    </div>
  </td>
);

export const NoData = ({ noDataMessage }: { noDataMessage: Message }) => (
  <td colSpan={2} style={{ padding: "40px 0px" }}>
    <div style={{ display: "inline-block", position: "sticky", left: "50%" }}>
      <big
        className="text-muted"
        style={{ display: "inline-block", transform: "translateX(-50%)" }}>
        <FormattedMessage {...noDataMessage} />
      </big>
    </div>
  </td>
);
